import axios from "axios";
import { store } from "@services/StateManagement/Store";
import { TranslateErrorMessage } from "../../ErrorHandling";

export const api: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SYS_API_URL,
});

export const sendRegisterDeviceRequest = async (
  deviceRegistrationId: string = "",
  tenantCode: string = "",
  password: string = "",
  revokeExisting: boolean = false,
) => {
  const header = store.getState().api.headers;
  api.defaults.headers = header;

  try {
    const response = await api.post(
      "v1/devices/register",
      {
        device_registration_id: deviceRegistrationId,
        tenant_code: tenantCode,
        password: password,
        revoke_existing: revokeExisting,
      },
      { responseType: "blob" },
    );

    const contentType = response.headers["content-type"];
    if (contentType?.includes("application/json")) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { error: json.error || "エラーが発生しました。" };
    }

    const p12Password = response.headers["x-p12-password"];

    const blob = new Blob([response.data], { type: "application/x-pkcs12" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const contentDisposition = response.headers["content-disposition"];
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
      : `${tenantCode}_認証証明_${new Date().toISOString()}.p12`;
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);

    return { p12Password };
  } catch (error: any) {
    console.log("Error downloading client certificate:", error.message);
    const errorMessage = TranslateErrorMessage(error.message);
    return { error: errorMessage || error.message || "エラーが発生しました。" };
  }
};
